import { FC } from 'react';

import { isBrandFilter } from '../../../../../../utils';
import BrandFilterItem from './BrandFilterItem';
import { BrandFiltersSectionProps } from './types';

const BrandFiltersSection: FC<BrandFiltersSectionProps> = ({
    currentFilterData,
    fieldPrefix,
    expandedFilters,
    toggleFilter,
    onFilterChange,
}) => {
    const brandFilters = currentFilterData.filter(isBrandFilter);

    if (brandFilters.length === 0) {
        return null;
    }

    return (
        <>
            {brandFilters.map(filterField => (
                <BrandFilterItem
                    key={filterField.code}
                    filterField={filterField}
                    fieldPrefix={fieldPrefix}
                    expandedFilters={expandedFilters}
                    toggleFilter={toggleFilter}
                    onFilterChange={onFilterChange}
                />
            ))}
        </>
    );
};

export default BrandFiltersSection;
